//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import helpRecord from './helpRecord'
import homeBG from '../../assets/homeChange/homeBG.png'
import { mapState, mapActions } from 'vuex'
export default {
    components:{
        helpRecord
    },
    data() {
        return {
            isMobile: !!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i),
            height: 228,
        }
    },
    computed: {
        ...mapState([
            'ownerView',
            'partner'
        ]),
    },
    mounted() {
        this.prelode()
        
    },
    methods: {
        prelode(){
            let _this = this
            var oImg = new Image()
            oImg.src = homeBG
            oImg.onload = oImg.onerror = function(e) {
                console.log(e)
                _this.height = e.type == 'load' ? Math.round(window.innerWidth / (oImg.width / oImg.height)) : _this.height
                // 预加载图片，计算图片容器的高
                _this.$forceUpdate()
            }
        },
        toQuery(){
            if(this.ownerView){
                GLOBAL.sign(this.ownerView.id, 'banner-hongDog')
            }else{
                GLOBAL.sign(0, 'banner-hongDog')
            }
            GLOBAL.setInfo('newQueryType', 3)
            this.$router.push({
                path:'query/queryContent',
                query: {
                    source: 'reddog'
                }
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/banner.vue